import styled from "@emotion/styled";
import { colors } from "styles/colors";

export const StarSVG = styled.svg`
  width: 30px;
  height: 30px;
  stroke: ${colors.STAR_ORANGE};
  stroke-linecap: round;
  fill: ${colors.STAR_ORANGE};
`;

export const StarContainer = styled.div`
  padding: 5px;
`;

export const RatingContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${StarContainer} {
    ${(props) => props.isEditable && `cursor: pointer;`}
  }
`;
